import * as sentry from "@sentry/react";

const trackFPRAnalytics = (
  eventName: string,
  data?: Record<string, unknown>,
) => {
  try {
    if (
      typeof window !== "undefined" &&
      typeof (window as any).fpr === "function"
    ) {
      (window as any).fpr(eventName, data);
    } else {
      console.warn(`FPR is not available. Event: ${eventName}`);
    }
  } catch (e) {
    console.error(`Error in trackFPRAnalytics: ${eventName}`, e);
    sentry.captureException(e);
  }
};

export const fprReferralEvent = (email: string) => {
  trackFPRAnalytics("referral", { email });
};

export default trackFPRAnalytics;
